import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../Translations';
import Button from '../../../../Form/Button';
import ImportParticipantsStore from '../../Store';
import { ImportedParticipantsResource, ViewReportAction } from '../../Store/Types';
import Table from './Table';

interface Props {
  store: ImportParticipantsStore;
  filename: string;
  totalCount: number;
  importedParticipantsResource: ImportedParticipantsResource;
  viewReport: ViewReportAction;
}

const ReportTable: React.FC<Props> = ({
  store,
  filename,
  totalCount,
  importedParticipantsResource,
  viewReport,
}) => {
  return (
    <div className="flex flex-col items-center px-2.5 py-5 lg:px-14">
      <div className="lg:w-[55%]">
        <h5 className="text-lg font-bold">
          <T kind="Report Table" />
        </h5>
        <p className="mb-7 text-base">
          <T
            kind="Showing {{successfulCount}} of {{totalCount}} records for <filename/>"
            totalCount={totalCount}
            successfulCount={importedParticipantsResource.payload.successfulParticipants.length}
            filename={<span className="font-bold">{filename}</span>}
          />
        </p>
        <div
          className={clsx(
            'mb-7 flex max-h-[calc(100vh-500px)] justify-center overflow-auto',
            'rounded-md border border-solid bg-gray-50',
          )}
        >
          <Table
            importedParticipantsResource={importedParticipantsResource}
            viewReport={viewReport}
          />
        </div>
        <div className="mt-5 flex justify-center">
          <Button
            type="button"
            onClick={store.uploadingReady}
            value="Upload a new file"
            className={clsx(
              'cursor-pointer rounded-md border border-solid font-semibold',
              'bg-teal-600 px-4 py-2 text-sm text-white',
            )}
          />
          <Button
            type="button"
            onClick={() => store.submitSucceeded(importedParticipantsResource)}
            value="Back to confirmation screen"
            className={clsx(
              'cursor-pointer rounded-md border border-solid font-semibold',
              'bg-teal-600 px-4 py-2 text-sm text-white ml-4',
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default observer(ReportTable);
